<template>
  <div>
    <zj-layout-container>
      <zj-layout-header style="paddingTop:50px;">
         开始时间：
         <el-date-picker
          v-model="chooseStartDate"
          type="date"
          format="yyyy-MM-dd"
          :clearable="false"
          @change="changeBegin"
          placeholder="选择日期">>
        </el-date-picker>
        <span style="margin-left:30px">结束时间：</span>
         <el-date-picker
          v-model="chooseEndDate"
          type="date"
          format="yyyy-MM-dd"
          :clearable="false"
          @change="changeEnd"
          placeholder="选择日期">>
        </el-date-picker>
        <el-button size="medium" style="margin-left:30px" @click="search">查询</el-button>
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_1">
            <div>
             性别占比
              <piechart
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="sexData"
              ></piechart>
            </div>
            <div>
             团票、散票占比
              <piechart
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="groupData"
              ></piechart>
            </div>
            <div>
             票型占比
              <piechart
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="ticketTypeData"
              ></piechart>
            </div>
          </div>
          <div class="echart_2">
            <div>
             年龄占比
              <barchart
                title=""
                xAxisName=""
                yAxisName=""
                :chartData="ageData"
              ></barchart>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import {getSexByTimes,getGroupDataByTimeValue,getAgeByTimes,getTypeByTimes} from '@/request/api';
import piechart from "@/views/echart/PieCharts"
import barchart from "@/views/echart/BarEchart"
export default {
  controller: "UI",
  action: "TourPortrayal",
  name: "TourPortrayal",
  components: {
    piechart,
    barchart
  },
  data(){
      return{
        chooseStartDate:new Date(),
        chooseEndDate:new Date(),
        sexData:[],
        groupData:[],
        ageData: {},
        ticketTypeData:[],
        params:{
          district: "652302",
          districtCode: "652302",
          polityType: 3,
          timeType:"year",
          timeValue: 1,
        }
      }
  },
  mounted: function () {
    this.search();
  },
  methods:{
    changeBegin() {
        if (this.chooseStartDate && this.chooseEndDate) {
            if (new Date(this.chooseStartDate).getTime() > new Date(this.chooseEndDate).getTime()) {
                this.chooseStartDate = ''
                this.$message({
                    type: "warning",
                    message: "开始时间不能大于结束时间",
                });
            }
        }
    },
    changeEnd() {
        if (this.chooseStartDate && this.chooseEndDate) {
            if (new Date(this.chooseStartDate).getTime() > new Date(this.chooseEndDate).getTime()) {
                this.chooseEndDate = ''
                this.$message({
                    type: "warning",
                    message: "开始时间不能大于结束时间",
                });
            }
        }
    },
    search(){
      this.params.startTime = this.chooseStartDate;
      this.params.endTime = this.chooseEndDate;
      getSexByTimes(this.params).then(res=>{
        if(res.data){
          let values = [];
          res.data = res.data.slice(0,2);//只用前两位，删除未知数据
          res.data.map(item=>{
              values.push({
                  name:item.name,
                  value:item.value
              })
          });
          this.sexData = values;
        }
      });

      getGroupDataByTimeValue(this.params).then(res=>{
        if(res.data){
          let values = [];
          res.data.map(item=>{
              values.push({
                  name:item.name,
                  value:item.count
              })
          });
          this.groupData = values;
        }
      });

      getTypeByTimes(this.params).then(res=>{
        if(res.data){
          let values = [];
          res.data.map(item=>{
              values.push({
                  name:item.name,
                  value:item.count
              })
          });
          this.ticketTypeData = values;
        }
      });

      getAgeByTimes(this.params).then(res=>{
        if(res.data){
          let obj = {
            days:[],
            data:[]
          };
          res.data = res.data.splice(0,res.data.length-1);
          res.data.map(item=>{
            obj.days.push(item.name);
            obj.data.push(item.value);
          });
          this.ageData = obj;
        }
      });

    },
  },
}
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 40%;
}
.echart_1{
  margin-bottom: 15px;
}
.echart_2{
  margin-top: 15px;
}
.echart_1 > div,
.echart_2 > div {
  float: left;
  width: 30%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
  text-align: center;
}
.echart_2 > div{
  width: 50%;
}
</style>